<template>
  <article class="popup error-login_popup">
    <img src="../../../assets/error_icon.svg" alt="">
    {{error(message)}}
    <close-btn></close-btn>
  </article>
</template>

<script>
  import closeBtn from '../closeBtn'

  export default {
    name: 'errorLogin',
    components: {
      closeBtn
    },
    computed: {
      mailError() {
        return this.$t('errors.mailFalse')
      },
      message() {
        return this.$store.state.auth.errorMessage
      }
    },
    methods: {
      error(mes) {
        switch (mes) {
          case('mail'): {
            return this.mailError;
          };break;
          default: return mes;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .error-login_popup {
    width: 500px;
    height: 300px;
    text-align: center;
    font-family: $mr;
    font-size: 16px;
    color: $darkBlue;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  img {
    margin-bottom: 20px;
    max-width: 100px;
  }
</style>
